import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import AdminDashboard from "./pages/AdminDashboard";
import AdminLogin from "./pages/AdminLogin";   // ✅ Import Admin Login
import FacultyLogin from "./pages/FacultyLogin";
import FacultyDashboard from "./pages/FacultyDashboard";
import StudentLogin from "./pages/StudentLogin";
import StudentDashboard from "./pages/StudentDashboard";
import ProtectedRouteStudent from "./components/ProtectedRouteStudent";
import ProtectedRouteFaculty from "./components/ProtectedRouteFaculty";
import ProtectedRouteAdmin from "./components/ProtectedRouteAdmin"; // ✅ Import new Protected Route
import { AuthProvider } from "./context/AuthContext";

function App() {
  // ✅ Faculty accounts list (demo)
  const facultyList = [
    { facultyId: "F101", password: "1234", name: "John Doe" },
    { facultyId: "F102", password: "abcd", name: "Jane Smith" },
  ];

  return (
    <AuthProvider>
      <Router>
        <Navbar />
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<Home />} />

          {/* Admin login */}
          <Route path="/admin-login" element={<AdminLogin />} />

          {/* Admin Dashboard (protected) */}
          <Route
            path="/admin-dashboard"
            element={
              <ProtectedRouteAdmin>
                <AdminDashboard />
              </ProtectedRouteAdmin>
            }
          />

          {/* Faculty login (with demo list) */}
          <Route
            path="/faculty-login"
            element={<FacultyLogin facultyList={facultyList} />}
          />

          {/* Faculty Dashboard (protected) */}
          <Route
            path="/faculty-dashboard"
            element={
              <ProtectedRouteFaculty>
                <FacultyDashboard />
              </ProtectedRouteFaculty>
            }
          />

          {/* Student login */}
          <Route path="/student-login" element={<StudentLogin />} />

          {/* Student Dashboard (protected) */}
          <Route
            path="/student-dashboard"
            element={
              <ProtectedRouteStudent>
                <StudentDashboard />
              </ProtectedRouteStudent>
            }
          />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
